import { useEffect, useState } from 'react'
import { useBodyScrollLock } from '../hooks/useBodyScrollLock.js'
import { prefersReducedMotion } from '../lib/motion.js'
import envelopeBodyLower from './envelope-assets/envelope-body-lower.webp'
import flapClosed from './envelope-assets/flap-closed.webp'
import waxSeal from './envelope-assets/wax-seal.webp'
import styles from './EnvelopeIntro.module.css'

type EnvelopeState = 'closed' | 'opening' | 'opened'

const OPEN_DURATION_MS = 1_000
const REDUCED_OPEN_DURATION_MS = 180

export interface EnvelopeIntroProps {
  interactive?: boolean
  onOpening?: () => void
  onOpened?: () => void
}

/** 첫 영상 앞에서 하객이 직접 여는 디지털 봉투다. */
export function EnvelopeIntro({ interactive = true, onOpening, onOpened }: EnvelopeIntroProps) {
  const [state, setState] = useState<EnvelopeState>('closed')
  useBodyScrollLock(state !== 'opened')

  useEffect(() => {
    if (state !== 'opening') return
    const duration = prefersReducedMotion() ? REDUCED_OPEN_DURATION_MS : OPEN_DURATION_MS
    const timer = window.setTimeout(() => {
      setState('opened')
      onOpened?.()
    }, duration)
    return () => window.clearTimeout(timer)
  }, [onOpened, state])

  if (state === 'opened') return null

  return (
    <div className={styles.screen} data-testid="envelope-intro" data-state={state}>
      <button
        type="button"
        className={styles.trigger}
        aria-label="봉투 열기"
        disabled={!interactive || state !== 'closed'}
        onClick={() => {
          onOpening?.()
          setState('opening')
        }}
      >
        <span className={styles.stage} aria-hidden="true">
          <span
            className={`${styles.panel} ${styles.topPanel}`}
            data-testid="envelope-top-panel"
          >
            <img className={styles.closedFlap} src={flapClosed} alt="" draggable={false} />
            <span className={styles.invited}>YOU&apos;RE INVITED</span>
            <span className={styles.seal}>
              <img src={waxSeal} alt="" draggable={false} />
              <span className={styles.monogram}>WY</span>
            </span>
          </span>
          <span
            className={`${styles.panel} ${styles.bottomPanel}`}
            data-testid="envelope-bottom-panel"
          >
            <img
              className={styles.lowerBody}
              src={envelopeBodyLower}
              alt=""
              draggable={false}
            />
            <span className={styles.openCue}>
              TAP TO OPEN
              <span className={styles.openHint}>봉투를 눌러 열어주세요</span>
            </span>
          </span>
        </span>
      </button>
    </div>
  )
}
